.card {
  background-color: var(--pgm-sys-color-surface-container);
  border-radius: 12px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
  padding: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-5);
}

.name {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
  overflow-wrap: anywhere;
}

.date {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}
